export default __webpack_public_path__ + "static/media/tailor.62d081d7.svg";